import { graphqlClient } from "@/core/api/graphql/client";
import GET_WALLET_BALANCE from "./getWalletBalanceQuery.graphql";

export interface IWalletBalance {
  id: string;
  balance: number;
  currency: string;
  isActive: boolean;
}

interface GetWalletBalanceResult {
  wallet?: IWalletBalance | null;
}

/**
 * Fetches the current wallet balance for a customer.
 * Returns null if the customer has no wallet or if the wallet is inactive.
 */
export async function getWalletBalance(customerId: string): Promise<IWalletBalance | null> {
  const { data } = await graphqlClient.query<GetWalletBalanceResult>({
    query: GET_WALLET_BALANCE,
    variables: { customerId },
    fetchPolicy: "no-cache",
  });

  return data?.wallet ?? null;
}
